// This is done outside of a saga to appease the popup blocker
// The rule is that a popup must be created in a function call with a user event as a direct ancestor
// We could create the popup beforehand and pass it through the action, but that won't work for Facebook, which uses it's own SDK
// This is also the reason for the synchronous XMLHttpRequest
// Since callbacks would break the call chain (probably)

import {
  get_redirect_url,
  submit_social_tracking,
} from "helpers/analytics-helpers"
import initializeFacebook from "helpers/facebook-initialize"

function open_twitter_share(share_properties, popup) {
  let ga_params = share_properties.gaParams ? share_properties.gaParams : {}
  submit_ga_event_click(
    "Shares",
    share_properties.clickType,
    share_properties.clickLabel,
    undefined,
    ga_params
  )
  submit_social_tracking("twitter", "tweet", share_properties.clickLabel)
  var twitter_url =
    "https://twitter.com/intent/tweet?text=" +
    encodeURIComponent(share_properties.message) +
    "&url=" +
    encodeURIComponent(share_properties.url)
  popup.location = get_redirect_url(twitter_url)
  //window.open(get_redirect_url(twitter_url),'_blank',"noopener=1,status=1,width=600,height=500");
}

function open_pinterest_share(share_properties, popup) {
  let ga_params = share_properties.gaParams ? share_properties.gaParams : {}
  submit_ga_event_click(
    "Shares",
    share_properties.clickType,
    share_properties.clickLabel,
    undefined,
    ga_params
  )
  submit_social_tracking("pinterest", "pin", share_properties.clickLabel)
  var pinterest_url =
    "https://pinterest.com/pin/create/button/?url=" +
    encodeURIComponent(share_properties.url) +
    "&media=" +
    encodeURIComponent(share_properties.imageUrl) +
    "&description=" +
    encodeURIComponent(share_properties.message)
  popup.location = get_redirect_url(pinterest_url)
  //window.open(get_redirect_url(pinterest_url),'_blank',"noopener=1,status=1,width=650,height=550");
}

function _openFacebookShare(share_properties) {
  initializeFacebook(() => {
    FB.ui(
      {
        display: "popup",
        hashtag: "#jewlr",
        href: share_properties.url,
        method: "share",
        quote: share_properties.message,
      },
      function () {}
    )
  })
}

function _openMessengerShare(share_properties) {
  //alert('_openMessengerShare');
  let ga_params = share_properties.gaParams ? share_properties.gaParams : {}
  if (Modernizr.touchevents) {
    submit_ga_event_click(
      "Shares",
      share_properties.clickType,
      share_properties.clickLabel,
      undefined,
      ga_params
    )
    window.open(
      "fb-messenger://share/?link=" +
        encodeURIComponent(share_properties.url) +
        "&app_id=" +
        window.jewlr.api.facebook.app_id
    )
  } else {
    initializeFacebook(() => {
      FB.ui(
        {
          link: share_properties.url,
          method: "send",
        },
        // callback
        function (response) {
          if (response && !response.error_message) {
            submit_ga_event_click(
              "Shares",
              share_properties.clickType,
              share_properties.clickLabel
            )
          } else {
            // alert('Error while posting.');
          }
        }
      )
    })
  }
}

function _openPinterestShare(share_properties, popup) {
  open_pinterest_share(share_properties, popup)
}

function _openTwitterShare(share_properties, popup) {
  open_twitter_share(share_properties, popup)
}

/**
 * Social media sharing
 * @param {string} share_type - social media type. ex, "Facebook", "Twitter"
 * @param {object} share_properties
 * share_properties = {
    clickType: {string} GA event click_type,
    clickLabel: {string} GA event opt_click_label,
    url: {string} share url,
    imageUrl: {string} image url,
    message: {string} share message
 }
 */
const doShare = ({ share_type = "Twitter", ...share_properties }) => {
  switch (share_type) {
    case "Messenger":
      _openMessengerShare(share_properties)
      break

    case "Facebook":
      _openFacebookShare(share_properties)
      break

    case "Pinterest":
      _openPinterestShare(share_properties, share_properties.popup)
      break

    case "Twitter":
      _openTwitterShare(share_properties, share_properties.popup)
      break

    default:
      alert("Unhandled share_type: " + share_type)
      break
  }
}

export default doShare
